import React from 'react';
import PropTypes from 'prop-types';

import StyledAddButton from './StyledAddButton';

function AddItemButton(props) {
  return (
    <StyledAddButton {...props}>Add Group</StyledAddButton>
  );
}

AddItemButton.propTypes = {
  className: PropTypes.string,
};

export default AddItemButton;



// WEBPACK FOOTER //
// ./app/components/AddItemButton/index.js